const S3Image = (filename,forceWebp = true) => {
    return `https://s3.us-west-2.amazonaws.com/citydata.media/citydata.ai/images/${forceWebp ? filename.replace("png","webp") : filename}`;
};

export default S3Image;